import Styles from './PostApproval.module.scss'
import { Button } from 'blaze-ui/Button'
import { useOpenIntegrations } from 'hooks/useOpenIntegrations'
import UserProfileAdd2 from 'blaze-ui/icons/20/UserProfileAdd2'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface ConnectButtonProps {
  goToNextFile?: () => void
}

export const ConnectButton = ({ goToNextFile }: ConnectButtonProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const openIntegrations = useOpenIntegrations()

  return (
    <div className={Styles.buttons}>
      <Button fullWidth frontIcon={goToNextFile ? undefined : UserProfileAdd2} onPress={openIntegrations}>
        {goToNextFile ? 'Connect' : 'Connect Accounts'}
      </Button>
      {goToNextFile && (
        <Button variant={isSystemRedesignEnabled ? 'secondary' : 'tertiary'} fullWidth onPress={goToNextFile}>
          See Next
        </Button>
      )}
    </div>
  )
}
